import { Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { showErrorSnackbar } from "../../../components/snackBar/snakbar";

export const Error404SnackbarComponent = ({ message }) => {
  return showErrorSnackbar(
    <Typography>
      {message}
      <span>
        <Link to="/emailsettings">Email settings</Link>
      </span>
    </Typography>
  );
}
